import { render, staticRenderFns } from "./IdeaCard.vue?vue&type=template&id=2187edfe&scoped=true&"
import script from "./IdeaCard.vue?vue&type=script&lang=js&"
export * from "./IdeaCard.vue?vue&type=script&lang=js&"
import style0 from "./IdeaCard.vue?vue&type=style&index=0&id=2187edfe&scoped=true&lang=less&"
import style1 from "./IdeaCard.vue?vue&type=style&index=1&id=2187edfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187edfe",
  null
  
)

export default component.exports